import { isJsonString } from '@js/globalFunctions/isJsonString'
import { getCookie } from '@js/globalFunctions/cookieHandling'
import getExcludedSearchFilters from "@js/parts/search/functions/searchfilterbox/getExcludedSearchFilters";

export function updateTagsView()
{
    if( $('#searcharea').length > 0 ) {
        const orderingCookie = getCookie('searchParamsDisplayOrder');
	    let html = '';
        if (searchParameters.hasParameters()) {
	        const excluded = getExcludedSearchFilters()

            const names = getKeyNames();
            const selected = searchParameters.getParameters();
            const ordered = (typeof orderingCookie !== 'undefined' && isJsonString(orderingCookie)) ? JSON.parse(orderingCookie) : Array();
            const keys = Object.keys(selected);
            const viableKeys = keys.filter((key) => {
            	return excluded.indexOf(key) === -1;
            });
            if (viableKeys.length !== 0) {
                html += '<h3>' + wpTranslatedStrings.search.yourChosenCriteria + '</h3>';

                let handled = [];
                for (let i = 0; i < ordered.length; i++) {
                	if(excluded.indexOf(ordered[i]) !== -1)
                		continue;

                    if (typeof selected[ordered[i]] !== 'undefined') {
                        let value = (ordered[i] === 'ankomst' && typeof selected['specificAnkomst'] !== 'undefined') ? selected['specificAnkomst'] : selected[ordered[i]];
                        const nameValueDisplay = determineNameValueDisplay(ordered[i], value, names);
                        html += '<li data-filter="' + $("<div>").text(ordered[i]).html() + '" class="searchFilterTag">' + nameValueDisplay + '</li>';
                        handled.push(ordered[i]);
                    }
                }

                for (let i = 0; i < keys.length; i++) {
	                if(excluded.indexOf(keys[i]) !== -1)
		                continue;

                    if (handled.indexOf(keys[i]) === -1) {
                        const nameValueDisplay = determineNameValueDisplay(keys[i], selected[keys[i]], names);

                        html += '<li data-filter="' + $("<div>").text(keys[i]).html() + '" class="searchFilterTag">' + nameValueDisplay + '</li>';
                    }
                }
            }
        }

	    $('#searcharea .searchTagsDisplay').html(html + '<div class="clearfix"></div>');
	    if (html === '') {
		    $('#searcharea .searchTagsDisplay').addClass('hidden');
	    }
	    else {
		    $('#searcharea .searchTagsDisplay').removeClass('hidden');
	    }

        // Hide background map when tags take up 3 lines
        if($('#searcharea .searchTagsDisplay').outerHeight() > 100)
        {
            $('#searcharea').addClass('searchTagsOver3Lines');
        }
        else
        {
            $('#searcharea').removeClass('searchTagsOver3Lines');
        }
    }
}

export function getKeyNames()
{
    var facilityDefaults = isJsonString($('#searcharea').attr('data-facilitynames')) ? JSON.parse($('#searcharea').attr('data-facilitynames')) : {};
    return {
        specials: wpTranslatedStrings.searchFilterNames,
        defaults: facilityDefaults
    }
}

export function determineNameValueDisplay(name, value, names)
{
    var valueDisplay = determineValueDisplay(name, value, names);

    if( ( typeof names.specials[name] !== 'undefined' && names.specials[name] !== '' ) || ( typeof names.defaults[name] !== 'undefined' && names.defaults[name] !== '' ) )
    {
        name = (typeof names.specials[name] !== 'undefined' ) ? names.specials[name] : names.defaults[name] ;
    }

    return $("<div>").text(name+valueDisplay).html()
}

export function determineValueDisplay(name, value, names)
{
    var valueDisplayRules = {
        143: {
            callback: function(){
                var valueDisplay = '';
                if( value === '1' )
                {
                    valueDisplay = '0-50 m²';
                }
                else if( value === '2' )
                {
                    valueDisplay = '50-100 m²';
                }
                else if( value === '3' )
                {
                    valueDisplay = '100-150 m²';
                }
                else if( value === '4' )
                {
                    valueDisplay = '150+ m²';
                }
                return valueDisplay;
            }
        },
        146: {
            callback: function(){
                return (value !== 'none' ) ? wpTranslatedStrings.sentences.withinXYears.replace('%i',3)  : ''
            }
        },
        152: {
            prefix: ': ',
            callback: function(){
                return (value === 'False') ? wpTranslatedStrings.terms.allowed : wpTranslatedStrings.terms.notAllowed ;
            }
        },
        158: {
            callback: function() {
	            if(value === 'none')
	            	return '';

                return (value === '1') ? wpTranslatedStrings.sentences.withinXYears.replace('%i', 3) : wpTranslatedStrings.sentences.newlyRenovated
            }
        },
        179: {
            suffix: 'm'
        },
        180: {
            suffix: 'm'
        },
        182: {
            suffix: 'm²'
        },
        husdyr: {
            callback: function(){
                if(value === "3")
                {
                    return '2+';
                }
                else if (value === '4'){
                    return wpTranslatedStrings.terms.noPets;
                }
                return value;
            }
        },
        badevaerelse: {
            callback: function(){
                valueDisplay = Math.ceil(Number(value)/2);
                if (value === '2' || value === '4' || value === '6' || value === '8' )
                {
                    valueDisplay += ' + ' + wpTranslatedStrings.terms.guestToilet
                }
                return valueDisplay;
            }
        },
        duration: {
            callback: function(){
                return wpTranslatedStrings.terms.xDays.replace('%i',value)
            }
        },
        maxPris: {
            suffix: ' ' + siteCurrencyDisplay
        },
        omraader: {
            callback: function(){
                var selected = value.split(',');
                return value === '' ? wpTranslatedStrings.terms.none : selected.length;
            }
        },
        skiftedag: {
            callback: function(){
                var selected = value.split(',');
                return (selected.length !== 1 ) ? selected.length : wpTranslatedStrings.search['searchDay_'+value];
            }
        },
        vejnavn: {
            callback: function(){
            	let text = '';
            	if(typeof value === 'object' && typeof value.length !== 'undefined')
	            {
	            	for(let i = 0; i < value.length; i++)
		            {
		                text +=  text = $('#vejnavn option[value="'+value[i]+'"]').text()+', ';
		            }
		            text = text.substring(0, text.length - 2);
	            }
            	else
	            {
		            text = $('#vejnavn option[value="'+value+'"]').text()
	            }
                return text;
            }
        },
	    ankomst: {
        	callback: function(){
                const text = $('#dateSelect option[value="'+value+'"]').text();
                let textParts = text.split(',');
		        return textParts.length > 1 ? textParts[textParts.length - 1] : text;
	        }
	    }
    };

    var valueDisplay = (value !== 'True' && value !== 'False') ? value : '';
    if( typeof valueDisplayRules[name] !== 'undefined' )
    {
        var ruleset = valueDisplayRules[name];

        if(typeof ruleset.callback !== 'undefined' )
        {
            valueDisplay = valueDisplayRules[name].callback();
        }

        if( typeof ruleset.prefix !== 'undefined' )
        {
            valueDisplay = ruleset.prefix+valueDisplay;
        }

        if( typeof ruleset.suffix !== 'undefined' )
        {
            valueDisplay = valueDisplay+ruleset.suffix;
        }
    }

    return (value !== 'True' && value !== 'False') ?  ': ' + valueDisplay : valueDisplay;
}
